<template>
  <div class="pure-form">
    <div class="nav__main__search__input ccrs__search__input">
      <div class="searchWrapper">
        <label
          class="label"
          for="ccrssearchinput"
        >
          {{ $tv('searchBarHeader', 'ccrs') }}
        </label>
        <input
          id="ccrssearchinput"
          class="pure-input-1 data-hj-allow"
          type="search"
          ref="ccrs-search"
          :placeholder="$tv('searchPlaceholder', 'ccrs')"
          v-model="searchTerm"
          @keyup.enter="runSearch"
          @click="openOverlay"
        >
        <WaitingIndicator
          class="nav__main__search__input__loading-indicator"
          v-if="isLoading"
        />
        <a
          v-show="searchTerm !== ''"
          class="ccrs__search__input__closing-icon"
          href="javascript:void(0)"
          :title="$tv('ClearSearch', 'searchResults')"
          @click="handleClearClick"
        ><NavigationClose />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import WaitingIndicator from '~/components/loading-indicators/waiting-indicator.vue'
import NavigationClose from '~/assets/icons/navigation_close.svg?component'

export default {
  components: {WaitingIndicator, NavigationClose},
  data() {
    return {
      searchTerm: ''
    }
  },
  props: {
    focus: {
      type: Boolean,
      required: false,
      default() {
        return false
      }
    },
    isLoading: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  methods: {
    handleClearClick() {
      this.searchTerm = ''
      const inputRef = this.$refs['ccrs-search']
      if (inputRef) {
        inputRef.focus()
        this.$emit('search-term', this.searchTerm)
      }
    },
    runSearch() {
      this.$emit('search-term', this.searchTerm)
    },
    openOverlay() {
      if (this.searchTerm.length > 0) {
        this.$emit('open-overlay')
      }
    }
  },
  watch: {
    searchTerm() {
      clearTimeout(this.timeout)

      this.timeout = setTimeout(async () => {
        await this.runSearch()
      }, 200)
    },
    '$route.path': {
      handler() {
        this.searchTerm = ''
      }
    }
  }
}
</script>

<style lang="scss">
.pure-form .nav__main__search__input.ccrs__search__input {
  .searchWrapper {
    max-width: 20rem;
    position: relative;

    @include breakpoint-down($md) {
      max-width: 100%;
    }

    .label {
      font-size: map-get($base-text-label-medium, font-size );
      font-weight: map-get($base-text-label-medium, font-weight );
      margin-bottom: .5rem;
    }

    input {
      padding-right: 3.75rem;
      padding-left: .5rem;
      margin-bottom: $default-margin-padding-width;
      position: relative;
      width: 100%;
      display: initial;
    }

    .nav__main__search__input__loading-indicator {
      position: absolute;
      top: 2rem;
      right: 2.25rem;
    }

    .ccrs__search__input__closing-icon {
      position: absolute;
      top: 2rem;
      right: .5rem;

      .icon--svg {
        font-size: 1.5rem;
        color: $color__black;
      }
    }
  }
}
</style>
